export const SET_BLOGLISTINFO = 'SET_BLOGLISTINFO';
export const SET_CATEGORIES = 'SET_CATEGORIES';
export const SET_BLOGRECENTPOSTS = 'SET_BLOGRECENTPOSTS';
export const SET_SHARES = 'SET_SHARES';